export class DiscoveryInvokeParams {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "regionsToScan",
            "baseName": "regionsToScan",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return DiscoveryInvokeParams.attributeTypeMap;
    }
    constructor() {
    }
}
